export default "__VITE_ASSET__CIQwdaPB__"